// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"fbf20d79","113":"5c96f4b0","135":"325b7f52","157":"c4a810d4","226":"56b21d9e","374":"1af37181","591":"c1f2790d","630":"ff31298d"}[chunkId] + ".chunk.js";
};